import React from "react";

const ShowImage = ({ item, url }) => {
  return (
    <div>
      <img
        src={`${process.env.REACT_APP_API_URL}/${url}/photo/${item._id}`}
        alt={item.name}
        style={{ maxHeight: "100%", maxWidth: "100%" }}
        className="mb-3"
      />
    </div>
  );
};

export default ShowImage;
